'use strict';
import { tns } from "tiny-slider"

class ProjectsListBlock {
    constructor(items) {
        items.forEach((item) => {
            tns({
                container: item,
                slideBy: 'item',
                autoplay: false,
                controls: true,
                nav: false,
                navPosition: 'bottom',
                speed: 250,
                mouseDrag: false,
                gutter: 8,
                controlsText: ['', ''],
                items: 1,
                loop: false,
                autoWidth: false,
                onInit: function (instance) {
                    instance.nextButton.ariaLabel = "Framåt";
                    instance.prevButton.ariaLabel = "Bakåt";
                },
                responsive: {
                    768: {
                        slideBy: 'page',
                        items: 2,
                        gutter: 24
                    },
                    992: {
                        slideBy: 'page',
                        items: 3,
                        gutter: 24
                    },
                }
            });
        });
    }
}

document.addEventListener("DOMContentLoaded", function () {
    const items = [...document.querySelectorAll('.projects-list__list')];
    if (items) {
        new ProjectsListBlock(items);
    }
});
